import { commonQueries, useLoginStore } from '@/shared/lib/store';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { ErrorPopup } from '@/shared/ui';
import { showToast } from '@/shared/utils/toast';
import { ContactPopup } from '@/widgets/modal';
import type { ReactNode } from 'react';

interface ContactPodButtonProps {
    publishData?: API.IntegPubDetail.Res;
    setsId?: string | number;
    styles: {
        button?: string;
        tooltip?: string;
    };
    buttonText?: ReactNode;
    articleIds?: string;
    renderPopup?: (onSave: ContactPodSaveHandler) => ReactNode;
}

export type ContactPodSaveHandler = (
    title: string,
    contents: string,
    errorType: string,
    articleIdsOverride?: string
) => void;

export function ContactPodButton({
    publishData,
    styles,
    buttonText,
    articleIds = '',
    setsId,
    renderPopup,
}: ContactPodButtonProps) {
    const { showModal, closeModal } = useModalStore();
    const { loginInfo } = useLoginStore();

    const { mutate } = commonQueries.postContactSavePod();

    const onSave: ContactPodSaveHandler = (
        title,
        contents,
        errorType,
        articleIdsOverride
    ) => {
        if (!title || !contents) {
            showToast('제목과 내용을 입력해주세요.', 2000, 'error');
            return;
        }
        const data = {
            errorType: errorType,
            memberId: loginInfo?.memberId,
            title: title,
            contents: contents,
            setsId: publishData?.publishInfoDetail?.setsId ?? setsId,
            originalSetsId: publishData?.publishInfoDetail?.originalSetsId,
            publishId: publishData?.publishInfoDetail?.publishId?.toString(),
            publishNm: publishData?.publishInfoDetail?.publishNm,
            articleIds: articleIdsOverride ?? articleIds,
        };
        const params = new URLSearchParams(
            Object.entries(data).reduce<Record<string, string>>((result, [key, value]) => {
                if (value !== undefined && value !== null) result[key] = String(value);
                return result;
            }, {})
        ).toString();
        mutate(params, {
            onSuccess: (res) => {
                if (res?.data?.code === 'SUCCESS') {
                    closeModal('contact-popup');
                    showToast('문의가 등록되었습니다.', 2000);
                } else {
                    showToast('문의 등록에 실패했습니다.', 2000, 'error');
                }
            },
            onError: () =>
                showModal({
                    isCustom: true,
                    id: 'error',
                    initContents: () => <ErrorPopup />,
                }),
        });
    };

    const onContact = () => {
        showModal({
            isCustom: true,
            id: 'contact-popup',
            initContents: () =>
                renderPopup ? renderPopup(onSave) : <ContactPopup type="pod" onSave={onSave} />,
        });
    };

    return (
        <button type="button" className={styles.button} onClick={onContact}>
            {buttonText}
        </button>
    );
}
